/**
 * Find-my-strategy resolve chrome — owned by Review (local phase, not a route).
 *
 * Belongs here: AllStatusWrapper / compute-error UI for a phase owned by the parent.
 * Does not belong here: starting HTTP (parent runs resolve on click) or risk ready UI.
 */
import { AllStatusWrapper } from '../../../../../components/execution/terminal/AllStatusWrapper'
import { TerminalStatus } from '../../../../../types/mf-execution.types'
import {
  DirectionalSlideSwap,
  SlideDirection
} from '../../shared/transitions/DirectionalSlideSwap'
import { RiskProfileErrorPage } from './RiskProfileErrorPage'

const RISK_PROFILE_LOADING_TITLE = 'Curating the right<br/>allocation strategy for you'

/** Local resolve chrome phase — owned by Review (not a route). */
export enum StrategyResolvePhase {
  Idle = 'idle',
  Loading = 'loading',
  ComputeError = 'compute_error'
}

/** Overlay only shows loading or compute-error — never Idle. */
export type StrategyResolveOverlayPhase =
  | StrategyResolvePhase.Loading
  | StrategyResolvePhase.ComputeError

type StrategyResolveOverlayProps = {
  phase: StrategyResolveOverlayPhase
  /** Compute-only retry after submit already succeeded. */
  onRetryCompute: () => void
  /** Leave compute-error chrome back to review. */
  onDismissError: () => void
}

/** Presentational resolve UI — parent owns when to call resolveStrategy / retry. */
export function StrategyResolveOverlay({
  phase,
  onRetryCompute,
  onDismissError
}: StrategyResolveOverlayProps) {
  if (phase === StrategyResolvePhase.ComputeError) {
    return (
      <RiskProfileErrorPage
        onBack={onDismissError}
        onRetry={onRetryCompute}
      />
    )
  }

  return (
    <DirectionalSlideSwap
      contentKey="strategy-resolve-loading"
      direction={SlideDirection.Forward}
    >
      <AllStatusWrapper
        status={TerminalStatus.LOADING}
        loadingConfig={{
          title: RISK_PROFILE_LOADING_TITLE,
          titleClassName: 'font-[500] text-[22px] leading-[130%]'
        }}
      />
    </DirectionalSlideSwap>
  )
}
